import React from 'react';
import { Card, CardContent } from './ui/card';
import { Badge } from './ui/badge';
import { Star, Quote } from 'lucide-react';
import { testimonials } from './mock';

const Testimonials = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <Badge className="mb-4 bg-blue-100 text-blue-800 hover:bg-blue-100">
            Nossas Avaliações
          </Badge>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            O que Nossos
            <span className="block text-blue-600">Clientes Dizem</span>
          </h2>
          <p className="text-xl text-gray-600">
            A satisfação dos nossos clientes é nossa maior conquista. 
            Veja alguns depoimentos de quem já teve a experiência Tecnote.
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid md:grid-cols-2 gap-8">
          {testimonials.map((testimonial) => (
            <Card 
              key={testimonial.id} 
              className="relative overflow-hidden border-2 hover:border-blue-200 hover:shadow-xl transition-all duration-300"
            >
              <CardContent className="p-8">
                {/* Quote Icon */}
                <div className="absolute -top-2 -right-2 w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center opacity-50">
                  <Quote className="w-8 h-8 text-yellow-600" />
                </div>
                
                {/* Rating */}
                <div className="flex items-center space-x-1 mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="w-5 h-5 text-yellow-500 fill-current" />
                  ))}
                </div>
                
                {/* Comment */}
                <blockquote className="text-gray-700 text-lg leading-relaxed mb-6">
                  "{testimonial.comment}"
                </blockquote>
                
                {/* Author */}
                <div className="flex items-center justify-between">
                  <div>
                    <div className="font-semibold text-gray-900">
                      {testimonial.name}
                    </div>
                    <div className="text-sm text-gray-600">
                      {testimonial.project}
                    </div>
                  </div>
                  
                  <Badge variant="outline" className="text-blue-700 border-blue-300">
                    Cliente Verificado
                  </Badge>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>

        {/* Google Reviews CTA */}
        <div className="text-center mt-12 bg-gradient-to-r from-blue-50 to-cyan-50 rounded-2xl p-8">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            Mais de 50 Avaliações 5 Estrelas
          </h3>
          <p className="text-gray-600 mb-6">
            Confira todas as nossas avaliações no Google e veja por que somos referência 
            em montagem de computadores em São José dos Campos.
          </p>
          
          <div className="flex items-center justify-center space-x-2 mb-6">
            <div className="flex items-center space-x-1">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="w-6 h-6 text-yellow-500 fill-current" />
              ))}
            </div>
            <span className="text-2xl font-bold text-gray-900">4.9</span>
            <span className="text-gray-600">(52 avaliações)</span>
          </div>
          
          <button
            onClick={() => window.open('https://www.google.com/search?q=tecnote&oq=tecnote&gs_lcrp=EgZjaHJvbWUyBggAEEUYOTIHCAEQABiABDIHCAIQABiABDIHCAMQABiABDIJCAQQABgKGIAEMgYIBRBFGD0yBggGEEUYPTIGCAcQRRg90gEHOTA2ajBqN6gCALACAA&sourceid=chrome&ie=UTF-8&zx=1770141123753&no_sw_cr=1#lrd=0x94cc4968e902523b:0xde98829a6984f3b2,1,,,,', '_blank')}
            className="bg-blue-600 hover:bg-blue-700 text-white px-6 py-3 rounded-lg font-semibold transition-colors"
          >
            Ver Todas as Avaliações
          </button>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;